import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-why-input',
  template: `
    <div>
      <ion-item [lines]="_itemLines" [ngClass]="_itemClass">
        <ion-label *ngIf="_labelText" position="floating" [ngClass]="_labelClass" for="_id">
          {{_labelText | translate}}
        </ion-label>
        <a *ngIf="_iconButton" [ngClass]="_iconButtonClass" [slot]="_iconSlot" (click)="toggleIcon(_id)">
          <ion-icon *ngIf="_iconName" [name]="_iconName" [ngClass]="_iconClass" [slot]="_iconSlot"></ion-icon>
        </a>
        <ion-icon *ngIf="!_iconButton && _iconName" [name]="_iconName"
                  [slot]="_iconSlot" [ngClass]="_iconClass" (click)="toggleIcon(_id)"></ion-icon>
        <ion-input [attr.type]="_type"
                   [inputmode]="_type"
                   [id]="_id" [ngClass]="_inputClass"
                   [name]="value"
                   [ngModel]="value"
                   (input)="updateValue($event.target)"
                   (focus)="onFocus()" (focusout)="outOfFocus()"
                   (ionFocus)="setFocus($event)"
                   (ionBlur)="setFocus($event)"
                   [readonly]="_readOnly"
                   [placeholder]="_placeHolderText | translate">
        </ion-input>
      </ion-item>
    </div>
  `,
  styles: []
})

export class AtomTextIconLabelComponent implements OnInit {
  @Input() _formGroupName: FormGroup;
  @Input() value: any;
  @Input() _id: string;
  @Input() _type: string;
  @Input() _placeHolderText: string;
  @Input() _labelText: string;
  @Input() _autoComplete: string;
  @Input() _inputClass: string;
  @Input() _labelClass: string;
  @Input() _iconName: string;
  @Input() _iconClass: string;
  @Input() _iconSlot = 'end';
  @Input() _iconState = false;
  @Input() _iconButton = false;
  @Input() _iconButtonClass: string;
  @Input() _itemLines = 'none';
  @Input() _itemClass: string;
  @Input() _readOnly: boolean;
  @Output() inputFocus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleInput: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  focus: boolean;

  constructor() {
  }

  onFocus() {
    this.focus = true;
  }

  setFocus($event) {
    this.inputFocus.emit($event.type === 'ionFocus');
  }

  toggleIcon(id) {
    // eslint-disable-next-line no-underscore-dangle
    this._iconState = !this._iconState;
    const inputElement = window.document.querySelector('#' + id) as HTMLInputElement;
    // eslint-disable-next-line no-underscore-dangle
    inputElement.type = this._iconState ? 'text' : 'password';
    // eslint-disable-next-line no-underscore-dangle
    this.toggleInput.emit(this._iconState);
  }

  outOfFocus() {
    this.focus = false;
  }

  ngOnInit(): void {
  }

  updateValue(obj: any) {
    this.value = obj.value;
    this.valueChange.emit(obj.value);
  }
}
